import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { VerifypatientService } from '../verifypatient.service';
import { TranslateService } from '@ngx-translate/core';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private translateService: TranslateService, private router: Router, private phrUtility: PhrutillsService, private spinner: NgxSpinnerService,private verifypatient:VerifypatientService) {
    //this.gvs.Token;
   }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    let user_Token = localStorage.getItem('AuthTokenwebServices');
    //let refresh_Token = localStorage.getItem('refreshToken');
    //let user_Token2 = this.gvs.GetToken();
    // if (user_Token) {
    //   request = this.addToken(request, user_Token);
    // }

    return next.handle(request).pipe(catchError(error=> {
      let user_Token = localStorage.getItem('AuthTokenwebServices');
      if(user_Token=="" || user_Token==undefined){

        this.verifypatient.lockScreenPage();
        this.spinner.hide();
        // this.phrUtility.showError("Session Expire");
        let text = "Session Expire";
        this.translateService.get('Alerts.session_expire').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtility.showError(text);
        return throwError(error.message);
      }
      if (error instanceof HttpErrorResponse && error.status === 401) {
        
        //this.router.navigateByUrl("/");
          // window.location.href = window.location.origin + '/';
          // this.spinner.hide('login');
        // if(error.error==null){
        //   //this.loginservice.RefreshTokenMethod();
        // }else{

        //this.phrUtility.showError("Session Expire");
        let text = "Session Expire";
        this.translateService.get('Alerts.session_expire').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtility.showError(text);
          this.verifypatient.lockScreenPage();
          //window.location.href = window.location.origin + '/';
          this.spinner.hide();
          return throwError(error.message);

      }
      //  else if(error.status === 404){
      //   return error.status;
      //  }
      else {
        return throwError(error.message);
      }
    }));
  }   
  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
  }
}
